/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import React, { useContext } from 'react';
import {
  Image,
  View,
  StyleSheet,
  TouchableOpacity,
  ScrollView,
} from 'react-native';

import { TooltipV } from '../TooltipV';
import { useHistory, useLocation, Prompt } from 'react-router-dom';
import { GoogleMapV } from '../../../../../../widgets/GoogleMapV';
import { useViewport } from '@vlinder-web/viewport-provider-react';
import Pointer from '../Pointer';
// import blueprint from "../../config/default-blueprint.json";
// import {DEFAULT_APP_CONFIG} from "../../../../config/default.config";

//const BP = blueprint.ProvenanceMap;
const BP: any = {};

interface ProvenanceMapProps {
  defaultCenter?: object;
  markers?: any[];
  defaultZoom?: number;
  googleMapAPIKey?: string;
}

export const ProvenanceMap = ({
  defaultCenter,
  markers,
  defaultZoom,
  googleMapAPIKey,
}: ProvenanceMapProps) => {
  console.log(
    `googleMapAPIKey :`,
    googleMapAPIKey,
    markers,
    defaultCenter,
    defaultZoom
  );
  const _getMarkers = () => {
    let modifiedMarker: any = [];
    markers &&
      Array.isArray(markers) &&
      markers.length > 0 &&
      markers.map((item, index) => {
        modifiedMarker.push({
          id: index,
          image: {
            uri: 'https://i.ibb.co/6Dm3fVJ/map-marker.png',
            size: 40,
            backgroundColor: 'blue',
          },
          title: item?.title ?? '',
          description: item?.description,
          lat: item?.lat,
          lng: item?.lng,
        });
      });
    console.log(`_markers geoJson:`, modifiedMarker);
    return modifiedMarker;
  };
  const _markers = markers && _getMarkers();
  const _defaultCenter = defaultCenter;
  const _defaultZoom = defaultZoom;
  //const _data = BP.data;
  const [size, setSize] = React.useState(Array(_markers?.length).fill(1));
  const [zoomCenter, setZoomCenter] = React.useState({
    center: _defaultCenter,
    zoom: _defaultZoom,
  });
  const history = useHistory();
  //const theme = useContext(ThemeContext);
  const { width, height } = useViewport();
  const styles = {
    contentContainer: {
      flexDirection: 'column',
      marginTop: 30,
      justifyContent: 'center',
      alignItems: 'center',
      alignSelf: 'center',
      width: 1 * width,
      height: '70vh',
      backgroundColor: '#ffffff',
      paddingBottom: 30,
    },
    tooltipIcon: {
      backgroundColor: 'transparent',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      shadowOpacity: 0.75,
      shadowRadius: 10,
      shadowColor: 'rgba(0,0,0,0.2)',
      shadowOffset: { height: 0, width: 0 },
    },
    thumbnailStyle: {
      width: 0.8 * width,
      height: 0.3 * height,
    },
  };

  const onChildClick = (key: number, childProps: any) => {};
  const onChildMouseEnter = (key: number, childProps: any) => {
    let _size = size;
    _size[key] = 1.8;
    setSize(_size);
  };
  const onChildMouseLeave = (key: number, childProps: any) => {
    let _size = size;
    _size[key] = 1;
    setSize(_size);
  };
  const onBoundsChange = (
    center: number[],
    zoom: number,
    bounds: number[],
    marginBounds: number[]
  ) => {};

  // const handleModalHide = () => {
  //   setShow(false);
  // }

  const handleTouchEnd = () => {
    // setShow(true);
    //  handleMarkerClick(BP);
    const data = {
      markers: _markers,
      defaultCenter: _defaultCenter,
      defaultZoom: _defaultZoom,
    };
    // history.push("/map", data);
  };

  const renderItem = (tooltip, index) => {
    //Currently supports only react icons/images, not react-native icons/images
    return (
      <View
        style={StyleSheet.flatten([
          styles.tooltipIcon,
          {
            backgroundColor: 'transparent',
            width: size[tooltip?.id] * (tooltip?.image?.size + 8),
            height: size[tooltip?.id] * (tooltip?.image?.size + 8),
            borderRadius: tooltip?.image?.size
              ? (size[tooltip?.id] * (tooltip?.image?.size + 8)) / 2
              : 0,
          },
        ])}
      >
        <Image
          key={index}
          source={{ uri: tooltip?.image?.uri }}
          style={{
            resizeMode: 'contain',
            backgroundColor: 'transparent',
            width: size[tooltip?.id] * tooltip?.image?.size,
            height: size[tooltip?.id] * tooltip?.image?.size,
            borderRadius: tooltip?.image?.size
              ? (size[tooltip?.id] * tooltip?.image?.size) / 2
              : 0,
          }}
        />
      </View>
    );
  };

  const renderMarker = (marker: object | any, index: number) => {
    console.log(`in renderMarker:`, marker, index);
    return <Pointer text={'A'} />;
    return (
      <TooltipV
        key={index}
        title={marker?.title}
        tooltipStyle={{
          maxWidth: 200,
          fontSize: 20,
          backgroundColor: '#EFB805',
        }}
        arrowStyle={{ color: '#EFB805' }}
        children={[marker]}
        renderItem={renderItem}
        placement={'top'}
        arrow
      />
    );
  };

  return (
    <View style={styles.contentContainer} onClick={handleTouchEnd}>
      <GoogleMapV
        width={0.8 * width}
        height={'70vh'}
        bootstrapURLKeys={{
          key: googleMapAPIKey,
        }}
        defaultCenter={defaultCenter && defaultCenter}
        defaultZoom={BP.defaultZoom}
        center={zoomCenter?.center}
        zoom={zoomCenter?.zoom}
        markers={_markers && _markers}
        renderMarker={renderMarker}
        onChildClick={onChildClick}
        onChildMouseEnter={onChildMouseEnter}
        onChildMouseLeave={onChildMouseLeave}
        onBoundsChange={onBoundsChange}
      />
    </View>
  );
};
